import { TMobileRouterPath } from "../hooks/router";
import { routes } from "../router/mobile/routes";

type IScreenTimeEvent = Partial<{
  [prop in Partial<TMobileRouterPath>]: string;
}>;

export const screenTimeEvent: IScreenTimeEvent = {
  [routes.dashboard.path]: "PSN Dashboard",
  [routes.myFacility.path]: "My Facility",
  [routes.clinical.path]: "Clinical Alerts",
  [routes.patientProfile.path]: "Profile Chart",
  [routes.reports.path]: "Reports",
  [routes.watchlist.path]: "Watchlist",
};
